import { render, staticRenderFns } from "./RequiredStepPayment.vue?vue&type=template&id=3c31382b&"
import script from "./RequiredStepPayment.vue?vue&type=script&lang=js&"
export * from "./RequiredStepPayment.vue?vue&type=script&lang=js&"
import style0 from "./RequiredStepPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports